type MetricsBlurOverlayProps = {
	enableBlur: boolean;
	children: React.ReactNode;
	/** `data-qualifier` of the wrapper; the overlay carries `${qualifier}/Stale` only while blurred. */
	qualifier?: string;
};

/**
 * Veils charts whose numbers are out of sync with the composition. Hovering the wrapper lifts the veil
 * (and lets clicks through to the chart) — in CSS via `group-hover`, so the wrapper stays a plain,
 * non-interactive element.
 */
export function MetricsBlurOverlay({ enableBlur, children, qualifier }: MetricsBlurOverlayProps): React.JSX.Element {
	return (
		<div className="group relative" data-qualifier={qualifier}>
			{children}
			<div
				data-qualifier={qualifier && enableBlur ? `${qualifier}/Stale` : undefined}
				className={`absolute inset-0 bg-white/40 z-10 transition-opacity duration-300 ${enableBlur ? "opacity-100 group-hover:opacity-0 group-hover:pointer-events-none" : "opacity-0 pointer-events-none"}`}
			/>
		</div>
	);
}
